import React from "react";
import { Modal } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { AuthZTable } from "../authZTable";
import "./index.css";
import AuthZButton from "../AuthzButton";
import { isNullOrUndefinedOrEmpty } from "../../common/utils";

export const PreviewModalComponent = ({
  visible,
  onCancel,
  okButtonProps,
  modalHeaderContent,
  modalCustomTitle,
  footer,
  className,
  tableProperties,
  destroyOnClose,
  ...restProps
}) => {
  const renderTitle = () => (
    <div className="preview-modal-title">
      <div className="preview-modal-title-left">
        <div className={"preview-title"}>{modalHeaderContent.title}</div>
        <div className={"preview-header-content"}>{modalHeaderContent.content}</div>
      </div>
      {(modalCustomTitle) ? modalCustomTitle :
        (
          <div className="preview-modal-title-right">
            <AuthZButton
              authZButtonType="secondary"
              onClick={onCancel}
              icon={<CloseOutlined />}
              buttonDisabled={okButtonProps.confirmLoading}
            >
              Cancel
            </AuthZButton>
            {okButtonProps.disabled === true ? null : (
              <AuthZButton
                authZButtonType="primary"
                onClick={okButtonProps.onOk}
                icon={<CheckOutlined />}
                buttonLoading={okButtonProps.confirmLoading}
              >
                {isNullOrUndefinedOrEmpty(okButtonProps.text) ? "Yes" : okButtonProps.text}
              </AuthZButton>
            )}
          </div>
        )}

    </div>
  );

  const defaultTableProperties = {
    scroll: { x: "max-content", y: "calc(52vh)" },
    loading: false,
    footer: null
  }

  const tableProps = {
    ...defaultTableProperties,
    ...tableProperties
  }

  return (
    <Modal
      title={renderTitle()}
      visible={visible}
      width={"90vw"}
      closeIcon={<div />}
      footer={(footer)?footer:null}
      className={`preview-modal ${className}`}
      onCancel={onCancel}
      closable={false}
      maskClosable={false}
      destroyOnClose={destroyOnClose ?? false}
      getContainer={restProps.getContainer ?? (() => document.body)}
    >
      <AuthZTable
        name={"submitPreview"}
        {...tableProps}
      />
    </Modal>
  );
};
